import { Page } from '~src/domains/common/enums/api';

export const NAMES_INPUT_ENABLED = [
  'UP-20956569-3', // Carnival Navigator - Production
  'UP-20956569-97', // Carnival Navigator - Staging
  'UP-20956569-7', // Carnival Navigator Tokenx - Production
  'UP-20956569-93', // Carnival Navigator Tokenx - Staging
];

const APP_ENV = process.env.PREACT_APP_ENV;
const MALU_URL = process.env.PREACT_APP_MALU_URL;
const DISABLE_CEVENTS = process.env.PREACT_APP_DISABLE_CEVENTS;
const MAX_POLL_CALLS = 15;
const NAME_REGEX = /[^A-Za-z\s-'.,]/gm;
const PREFERRED_NUM_PAYMENTS = 11;
const XHR_TIMEOUT = 30000;
const MIN_INCOME_US = 10_000_00;
const MAX_INCOME_US = 300_000_00;
const MIN_INCOME_CA = 15_000_00;
const MAX_INCOME_CA = 300_000_00;

const VALID_MONTH_ENDS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const VALID_REGION_MAP_US = {
  AL: true,
  AK: true,
  AZ: true,
  AR: true,
  AA: true,
  AE: true,
  AP: true,
  CA: true,
  CO: true,
  CT: true,
  DE: true,
  DC: true,
  FL: true,
  GA: true,
  GU: true,
  HI: true,
  ID: true,
  IL: true,
  IN: true,
  IA: true,
  KS: true,
  KY: true,
  LA: true,
  ME: true,
  MD: true,
  MA: true,
  MI: true,
  MN: true,
  MS: true,
  MO: true,
  MT: true,
  NE: true,
  NV: true,
  NH: true,
  NJ: true,
  NM: true,
  NY: true,
  NC: true,
  ND: true,
  MP: true,
  OH: true,
  OK: true,
  OR: true,
  PA: true,
  PR: true,
  RI: true,
  SC: true,
  SD: true,
  TN: true,
  TX: true,
  UT: true,
  VT: true,
  VI: true,
  VA: true,
  WA: true,
  WV: true,
  WI: true,
  WY: true,
};
const VALID_REGION_MAP_CA = {
  AB: true,
  BC: true,
  MB: true,
  NB: true,
  NL: true,
  NT: true,
  NS: true,
  NU: true,
  ON: true,
  PE: true,
  QC: true,
  SK: true,
  YT: true,
};
const PO_BOX_REGEX =
  /^(\s*[a-zA-Z0-9]*\s+)?(p[,. ]*o[,. ]*b[,. ]*o[,. ]*x[,. ]*[0-9]*)?$/gim;
const EMAIL_REGEX =
  /^[^\s,@*.]+(?:\.[^\s,@*.]+)*@[^\s,@.]+(?:\.[^\s,@.]{1,63})*(?:\.[^\s,@.]{2,63})+$/gim;

const HIDE_WRAPPER_PAGES: { [key in Page]?: boolean } = {
  [Page.INITIAL]: true,
  [Page.EMPTY]: true,
  [Page.FAQ]: true,
};

export {
  APP_ENV,
  MALU_URL,
  DISABLE_CEVENTS,
  MAX_POLL_CALLS,
  NAME_REGEX,
  PREFERRED_NUM_PAYMENTS,
  XHR_TIMEOUT,
  MAX_INCOME_CA,
  MIN_INCOME_CA,
  MAX_INCOME_US,
  MIN_INCOME_US,
  VALID_MONTH_ENDS,
  VALID_REGION_MAP_US,
  VALID_REGION_MAP_CA,
  PO_BOX_REGEX,
  EMAIL_REGEX,
  HIDE_WRAPPER_PAGES,
};

export const OFFERS_TAG_ENABLED = [
  'UP-43928860-52', //NCL US INBOUND
  'UP-43928860-50', //NCL US OUTBOUND
  'UP-37292414-86', //QA Automation
  'UP-27021310-82', //QA Automation
  'UP-37292414-85', //QA Automation
  'UP-27021310-83', //QA Automation
  'UP-27021310-11', //QA Automation
  'UP-27021310-84', //QA Automation
  'UP-27021310-85', //QA Automation
  'UP-79934337-59', //QA Automation
  'UP-34161755-51', //QA Automation
  'UP-79934337-55', //QA Automation
  'UP-79934337-98', //QA Automation
  'UP-79934337-50', //QA Automation
  'UP-79934337-59', //QA Automation
  'UP-47887535-50', //QA Automation
  'UP-13566758-53', //QA Automation
];
